import { ServerError, ErrorBuilder, ErrorDefinition } from "@flaminem/utils";

import { useErrorDefinitions } from "./errorDefinitions.ts";

// returns an error builder that knows how to get language texts
export const getErrorBuilder = <T extends string>(
  errorDefs: Record<T, ErrorDefinition>
): ErrorBuilder<T> => {
  return (code: T, error?: Error | null | undefined): ServerError<T> => {
    const errorDef = errorDefs[code] ?? errorDefs["UNKNOWN-ERROR"];
    if (code === "SERVER-ERROR") {
      const serverError = errorDefs["SERVER-ERROR"];
      return {
        title: serverError.title,
        message: error?.message ?? serverError.message,
        type: errorDef.type ?? "Error",
        code: code,
        error,
      };
    }

    return {
      title: errorDef.title,
      message: errorDef.message,
      type: errorDef.type ?? "Error",
      code: code,
      error,
    };
  };
};

export type ErrorCode = keyof ReturnType<typeof useErrorDefinitions>;
